module.exports = __webpack_public_path__ + "static/jungle-minds-logo-3a6cffda64e92de0732512d536ff0e24.png";